import { render, staticRenderFns } from "./StoresButtons.vue?vue&type=template&id=32b6c67c&scoped=true&"
import script from "./StoresButtons.vue?vue&type=script&lang=js&"
export * from "./StoresButtons.vue?vue&type=script&lang=js&"
import style0 from "./StoresButtons.vue?vue&type=style&index=0&id=32b6c67c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b6c67c",
  null
  
)

export default component.exports